import { Center, Text, Heading, Box, Container } from '@chakra-ui/react';
import Mnemonic from '../../components/mnemonic/mnemonic';
import BottomActions from '../../components/bottomActions/bottomActions';
import { useCallback, FunctionComponent, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as wActions from '../../redux/wallet/actionCreators';
import PageBody from '../../components/pageBody/pageBody';
import BasicSlide from '../../components/basicSlide/basicSlide';

import LottieLoader from '../../components/lottieLoader/lottieLoader';
import { CreationSteps } from '../../redux/wallet/types';
import Footer from '../../components/footer/footer';

type WalletCreationProps = {
    wallet?: any;
    loading: boolean;
    walletActions?: any;
    creationStep: CreationSteps;
};

const WalletCreation: FunctionComponent<WalletCreationProps> = ({
    wallet,
    loading,
    creationStep,
    ...props
}) => {
    const history = useHistory();
    const walletActions: typeof wActions = props.walletActions;

    // Generates a new wallet instance
    const generateWallet = useCallback(() => {
        walletActions.generateWallet();
    }, [wallet]);

    const handleNextStep = useCallback(() => {
        walletActions.walletStepsNext();
    }, [creationStep]);

    if (loading) {
        return (
            <>
                <PageBody>
                    <Center>
                        <LottieLoader
                            animation='calculations'
                            w='200px'
                            h='200px'
                            loadingText='. . . generazione della tua chiave privata in corso!'
                        />
                    </Center>
                </PageBody>
                <Container maxW='6xl'>
                    <Footer />
                </Container>
            </>
        );
    }

    return (
        <>
            <PageBody>
                <Container>
                    <Center height='100%'>
                        {creationStep === CreationSteps.INITIAL && (
                            <BasicSlide
                                title='Crea il tuo Wallet su Ethereum'
                                imageSource='/images/wallet.svg'
                                description='Tieniti forte, allaccia le cinture e premi su Inizia'
                                buttonText='Inizia'
                                onClick={handleNextStep}
                                layoutType='normal'
                            />
                        )}

                        {creationStep === CreationSteps.PRIVATE_KEY &&
                            !wallet && (
                                <BasicSlide
                                    title='Chiave privata'
                                    imageSource='/images/private-key.svg'
                                    description='Tutto nasce dalla creazione di una chiave privata'
                                    buttonText='Genera!'
                                    onClick={generateWallet}
                                    layoutType='normal'
                                />
                            )}

                        {creationStep === CreationSteps.PRIVATE_KEY && wallet && (
                            <BasicSlide
                                title='Ecco la tua chiave privata!'
                                description="Conservala e non farla vedere a nessuno! Per identificare il tuo Wallet su Ethereum (ad esempio per ricevere transazioni) utilizza invece l'indirizzo (o Address) calcolato a partire dalla tua chiave privata"
                                buttonText='Calcola Address'
                                onClick={handleNextStep}
                                layoutType='inverted'
                            >
                                <Box p={4} borderRadius={8} bg='gray.200'>
                                    <Heading size='md'>
                                        {wallet.privateKey}
                                    </Heading>
                                </Box>
                            </BasicSlide>
                        )}

                        {creationStep === CreationSteps.PUBLIC_KEY && wallet && (
                            <BasicSlide
                                title='Questo è il tuo Address'
                                description="Rappresenta l'identificativo del tuo Wallet su Ethereum, un po' come l'IBAN di un conto corrente bancario"
                                buttonText='Vai al tuo Wallet!'
                                onClick={() => history.replace('/wallet')}
                                layoutType='inverted'
                            >
                                <Box p={4} borderRadius={8} bg='gray.200'>
                                    <Heading size='md'>
                                        {wallet.address}
                                    </Heading>
                                </Box>
                            </BasicSlide>
                        )}
                    </Center>
                </Container>
            </PageBody>
            <Container maxW='6xl'>
                <Footer />
            </Container>
        </>
    );
};

const mapStateToProps = ({ wallet }: any) => {
    return {
        wallet: wallet.wallet,
        loading: wallet.loading,
        creationStep: wallet.creationStep,
    };
};

const mapDispatchToProps = (dispatch: any) => ({
    walletActions: bindActionCreators(wActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(WalletCreation);
